// extracted by mini-css-extract-plugin
module.exports = {"ht-menu-item":"DevlinkMenuItem_ht-menu-item__le7FD","ht-menu-item-img":"DevlinkMenuItem_ht-menu-item-img__rvWji","ht-menu-item-text":"DevlinkMenuItem_ht-menu-item-text__HoJ7s"};